import {XSRFToken} from '../../@types/services/CSRFProtection';
import app from '../../helpers/app';

export function getXSRFToken(): XSRFToken | null {
    return app('cookies').get('XSRF-TOKEN') as string | null;
}

export function setXSRFToken(token: XSRFToken) {
    return app('cookies').set('XSRF-TOKEN', token);
}
